import './App.css';
import axios from 'axios';
import {useEffect, useState} from 'react';
import Categorias from './Components/Categorias/Categorias';
import Navbar from './Components/Navbar/Navbar';
import List from './Components/List/List';
import Footer from './Components/Footer/Footer';
import { Spinner } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { COLOR_CUERPO_CLARO, FOOTER_ACTIVADO, CATEGORIA_TODOS_ACTIVADO, BOTON_WHATSAPP_ACTIVADO, NUMERO_WHATSAPP } from './Config.js';
import { useClients } from './context/ClientContext.js';

const App = () => {
  const initialDates = [{
    ID: "",
    Name: "",
    Description: "",
    Price: "",
    Category: "",
    Image: ""
  }]

  const {getPlugin} = useClients();
  const [datos, setDatos] = useState(initialDates);
  const [categorias, setCategorias] = useState([]);
  const [catActiva, setCatActiva] = useState("Todos"); 
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {  
      const readSpreadsheet = async (host) => {
        try {
          setIsLoading(true);
          const res = await axios(host);
          const dat = await res.data;
          const result = await dat.data;
          setDatos(result);
          obtenerCategorias(result);
          setIsLoading(false);
        } catch(e)  {}
      }

      const obtenerCategorias = (result) => {
        let catArr = []
        if(CATEGORIA_TODOS_ACTIVADO) {
          catArr = ["Todos"]
        }
        const cat = result.map(row => {
          if (!catArr.includes(row.Category)) {
            catArr.push(row.Category);
          }
        })
        
        if (catArr.includes("")) {
          catArr = catArr.filter(c => c != "")
        }
        setCategorias(catArr);
        if(!CATEGORIA_TODOS_ACTIVADO) {
          setCatActiva(catArr[0]);
        }
      }

      const getHost = async () => {
        const host = await getPlugin();
        readSpreadsheet(host);
      }

      getHost();
  }, [])

  const seleccionada = (activa) => {
    setCatActiva(activa);
  }

  return (
    <div className={COLOR_CUERPO_CLARO ? 'app' : 'app oscuro'}>
      <Navbar />
      <div className='container'>
        {!isLoading
        ? <div> 
            <Categorias datos={categorias} selec={seleccionada} />
            <List datos={datos} selec={catActiva} />
            {FOOTER_ACTIVADO && <Footer />}
            {BOTON_WHATSAPP_ACTIVADO && (
              <>
                <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css" />
                <a href='https://api.whatsapp.com/send?phone=5492915714693&text=Hola%20Mysha!%20Quiero%20hacer%20un%20pedido' className="float" target="_blank">
                  <i className="fa fa-whatsapp my-float"></i>
                </a>
              </>
              )
            }
          </div>
        : <div className={COLOR_CUERPO_CLARO ? 'spinnerContainer' : 'spinnerContainer oscuro'}>
              <Spinner />
          </div>
        }
      </div>
    </div>
  );
}

export default App;